import { connect } from 'react-redux';
import { getIsHotelOnly, getIsWhitelabel } from 'src/store/view/selectors';
import { getIsNewVariant } from 'src/store/reviews/selectors';
import { setVariant, showHotelReviewsAction } from 'src/store/reviews/slice';
import { sendExperimentResultAction } from 'src/store/experimentStats/actions';
import LayoutDesktop from './LayoutDesktop';
import { getHotelRoulette } from '../../store/hotel';
import { getIsShowHotelFAQ } from '../../store/hotel/selectors';

const mapStateToProps = (state) => ({
  isRoulette: getHotelRoulette(state),
  isHotelOnly: getIsHotelOnly(state),
  isNew: getIsNewVariant(state),
  isShowHotelFAQ: getIsShowHotelFAQ(state),
  isWhitelabel: getIsWhitelabel(state),
});

const mapDispatchToProps = {
  showHotelReviews: showHotelReviewsAction,
  sendExperimentResult: sendExperimentResultAction,
  setVariantReviews: setVariant,
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutDesktop);
